import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { IPlan, IPlanResponse, ROUTES } from '@common/interfaces';
import { CommonHttpService } from 'libs/common/src/lib/service/common-http.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-subscription-plan',
  templateUrl: './subscription-plan.component.html',
  styleUrls: ['./subscription-plan.component.scss']
})
export class SubscriptionPlanComponent {
  loaderView: boolean = false;
  plans: IPlan[] = [];
  constructor(
    private commonHttpService: CommonHttpService,
    private router: Router,
    private toastrService: ToastrService
  ){}

  ngOnInit(){
    this.getPlans();
  }
  getPlans(){
    this.loaderView = true;
    this.commonHttpService.getAllPlans().subscribe({
      next: (response:IPlanResponse) => {
        this.plans = response.data;
        this.loaderView = false;
      },
      error: (err) => {
        const errorMessage = 'Error Fetching Plans Please Try Again Later'
        this.toastrService.error(errorMessage, '', {
          toastClass: 'toaster-wrapper',
        });
        this.loaderView = false;
      }
    })
  }
  createPlan(){
    this.router.navigate([ROUTES.CREATE_SUBSCRIPTION_PLAN])
  }
  editPlan(planId: any){
    this.router.navigate([ROUTES.CREATE_SUBSCRIPTION_PLAN],
      {queryParams : planId}
    )
  }
}
